const adicionarDias = (data, dias) => {
    data.setDate(data.getDate() + dias);

    return data;
}

const adicionarMeses = (data, meses) => {
    var mesEsperado = ((data.getMonth() + meses) % 12 + 12) % 12;

    data.setMonth(data.getMonth() + meses);

    if (data.getMonth() !== mesEsperado) {
        data.setDate(0);
    }

    return data;
}

const adicionarAnos = (data, anos) => {
    data.setFullYear(data.getFullYear() + anos);

    return data;
}

const retornaDatasCfeTipoPeriodo = (tipoPeriodo) => {
    if(!tipoPeriodo) return;

    let dataInicial = new Date();
    let dataFinal = new Date();
    let currentDayOfWeek;

    switch (tipoPeriodo) {
        case 1: // Todos
            dataInicial = new Date(1900,0,1,1,1,1,1);
            dataFinal = new Date(2099,0,1,1,1,1,1);
            break;
        case 2: // Ontem
            adicionarDias(dataInicial, -1);
            adicionarDias(dataFinal, -1);
            break;
        case 3: // Hoje
            break;
        case 4: // Amanhã
            adicionarDias(dataInicial, 1);
            adicionarDias(dataFinal, 1);
            break;
        case 5: // Esta semana
            currentDayOfWeek = (new Date).getUTCDay();
            adicionarDias(dataInicial, -currentDayOfWeek);
            adicionarDias(dataFinal, -currentDayOfWeek + 6);
            break;
        case 6: // Semana que vem
            currentDayOfWeek = (new Date).getUTCDay();
            adicionarDias(dataInicial, -currentDayOfWeek + 7);
            adicionarDias(dataFinal, -currentDayOfWeek + 13);
            break;
        case 7: // Semana passada
            currentDayOfWeek = (new Date).getUTCDay();
            adicionarDias(dataInicial, -currentDayOfWeek - 7);
            adicionarDias(dataFinal, -currentDayOfWeek - 1);
            break;
        case 8: // Este mês
            dataInicial.setDate(1);
            adicionarMeses(dataFinal, 1);
            dataFinal.setDate(0);
            break;
        case 9: // Mês que vem
            adicionarMeses(dataInicial, 1);
            dataInicial.setDate(1);
            adicionarMeses(dataFinal, 2);
            dataFinal.setDate(0);
            break;
        case 10: // Mês passado
            adicionarMeses(dataInicial, -1);
            dataInicial.setDate(1);
            dataFinal.setDate(0);
            break;
        case 11: // Este ano
            dataInicial.setDate(1);
            dataInicial.setMonth(0);
            dataFinal.setMonth(12);
            dataFinal.setDate(0);
            break;
        case 12: // Ano que vem
            dataInicial.setDate(1);
            dataInicial.setMonth(0);
            adicionarAnos(dataInicial, 1);
            dataFinal.setMonth(12);
            dataFinal.setDate(0);
            adicionarAnos(dataFinal, 1);
            break;
        case 13: // Ano passado
            dataInicial.setDate(1);
            dataInicial.setMonth(0);
            adicionarAnos(dataInicial, -1);
            dataFinal.setMonth(12);
            dataFinal.setDate(0);
            adicionarAnos(dataFinal, -1);
            break;
        }

    dataInicial.setHours(0);
    dataInicial.setMinutes(0);
    dataInicial.setSeconds(0);
    dataInicial.setMilliseconds(0);
    dataFinal.setHours(23);
    dataFinal.setMinutes(59);
    dataFinal.setSeconds(59);
    dataFinal.setMilliseconds(0);

    return {
        dataInicial,
        dataFinal
    };
}

export { retornaDatasCfeTipoPeriodo };